// extracted by mini-css-extract-plugin
export default {"component":"lD8n9"};